<nav class="bottom-bar">
  <div class="nav-tabs">
    @for (tab of tabs(); track tab.segment) {
      <button
        class="tab"
        [class.active]="isActive(tab)"
        (click)="navigateTo(tab)"
        type="button"
      >
        <div class="tab-icon-wrapper">
          <div class="active-pill"></div>
          <span [class]="tab.icon + ' tab-icon'"></span>
        </div>
        <span class="tab-label">{{ tab.labelKey | translate }}</span>
      </button>
    }
  </div>
</nav>
